import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import classes from "./Section1.module.css";
import photo from "../../assests/img/john-doe.webp";
import { Link } from "react-router-dom";

const Section1 = ({ darkSide, toggleDarkMode }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    nextArrow: (
      <button
        data-role="none"
        className="slick-arrow slick-next css-1h78vxn"
        // style="display:block"
      >
        <svg
          stroke="currentColor"
          fill="currentColor"
          stroke-width="0"
          viewBox="0 0 320 512"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path>
        </svg>
      </button>
    ),
    prevArrow: (
      <button
        data-role="none"
        className="slick-arrow slick-prev css-1h78vxn"
        // style="display:block"
      >
        <svg
          stroke="currentColor"
          fill="currentColor"
          stroke-width="0"
          viewBox="0 0 320 512"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path>
        </svg>
      </button>
    ),
  };
  return (
    <div
      className={darkSide === true ? classes["section1-dark"] : classes["section1-light"]}
    >
      <div style={{ marginLeft: "40px", marginRight: "40px" }}>
        <h2 className={classes["featured"]}>Latest Blogs</h2>
        <Slider {...settings}>
          <div className={classes["main-box"]}>
            <div className={classes["cat-name"]}>
              <p>React</p>
            </div>
            <Link to="/detail">
              <h3>How To Create a Responsive Top Navigation Menu</h3>
            </Link>
            {/* <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Explicabo, distinctio aperiam! Iusto quae nemo veniam, sapiente
              sit blanditiis fugiat neque!
            </p> */}
            <div style={{ marginTop: 20 }} class="flex items-center space-x-4">
              <img
                style={{
                  background: "#E2E8F0",
                  width: "50px",
                  marginRight: 15,
                }}
                class="w-10 h-10 rounded-full"
                src={photo}
                alt=""
              />
              <div class="font-medium dark:text-white">
                <div style={{ color: "#fff" }}>Jese Leos</div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "#fff",
                  }}
                >
                  <div
                    style={{ color: "#fff" }}
                    class="text-sm text-gray-500 dark:text-gray-400"
                  >
                    May 26,2020
                  </div>
                  <svg
                    style={{ marginRight: 10, marginLeft: 10 }}
                    stroke="currentColor"
                    fill="#fff"
                    stroke-width="0"
                    viewBox="0 0 512 512"
                    class="css-uk6cul"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                  </svg>
                  2min
                </div>
              </div>
            </div>
            <div className={classes["eye-main"]}>
              <div className={classes["eye-container"]}>
                <svg
                  style={{ width: "20px", fill: "#fff" }}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 576 512"
                >
                  <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z" />
                </svg>
                <p>1000</p>
              </div>
              <svg
                style={{ width: "20px", fill: "#fff", marginLeft: "25px" }}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
              >
                <path d="M384 24c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22V224H352 337.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C242.8 374.8 160 333.4 160 240c0-79.5 64.5-144 144-144h80V24zM0 144C0 99.8 35.8 64 80 64H96c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V416c0-17.7 14.3-32 32-32s32 14.3 32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V144z" />
              </svg>
            </div>
          </div>
          <div className={classes["main-box"]}>
            <div className={classes["cat-name"]}>
              <p>React</p>
            </div>
            <Link to="/detail">
              <h3>How To Create a Responsive Top Navigation Menu</h3>
            </Link>
            {/* <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Explicabo, distinctio aperiam! Iusto quae nemo veniam, sapiente
              sit blanditiis fugiat neque!
            </p> */}
            <div style={{ marginTop: 20 }} class="flex items-center space-x-4">
              <img
                style={{
                  background: "#E2E8F0",
                  width: "50px",
                  marginRight: 15,
                }}
                class="w-10 h-10 rounded-full"
                src={photo}
                alt=""
              />
              <div class="font-medium dark:text-white">
                <div style={{ color: "#fff" }}>Jese Leos</div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "#fff",
                  }}
                >
                  <div
                    style={{ color: "#fff" }}
                    class="text-sm text-gray-500 dark:text-gray-400"
                  >
                    May 26,2020
                  </div>
                  <svg
                    style={{ marginRight: 10, marginLeft: 10 }}
                    stroke="currentColor"
                    fill="#fff"
                    stroke-width="0"
                    viewBox="0 0 512 512"
                    class="css-uk6cul"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                  </svg>
                  2min
                </div>
              </div>
            </div>
            <div className={classes["eye-main"]}>
              <div className={classes["eye-container"]}>
                <svg
                  style={{ width: "20px", fill: "#fff" }}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 576 512"
                >
                  <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z" />
                </svg>
                <p>1000</p>
              </div>
              <svg
                style={{ width: "20px", fill: "#fff", marginLeft: "25px" }}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
              >
                <path d="M384 24c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22V224H352 337.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C242.8 374.8 160 333.4 160 240c0-79.5 64.5-144 144-144h80V24zM0 144C0 99.8 35.8 64 80 64H96c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V416c0-17.7 14.3-32 32-32s32 14.3 32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V144z" />
              </svg>
            </div>
          </div>
          <div className={classes["main-box"]}>
            <div className={classes["cat-name"]}>
              <p>React</p>
            </div>
            <Link to="/detail">
              <h3>How To Create a Responsive Top Navigation Menu</h3>
            </Link>
            {/* <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Explicabo, distinctio aperiam! Iusto quae nemo veniam, sapiente
              sit blanditiis fugiat neque!
            </p> */}
            <div style={{ marginTop: 20 }} class="flex items-center space-x-4">
              <img
                style={{
                  background: "#E2E8F0",
                  width: "50px",
                  marginRight: 15,
                }}
                class="w-10 h-10 rounded-full"
                src={photo}
                alt=""
              />
              <div class="font-medium dark:text-white">
                <div style={{ color: "#fff" }}>Jese Leos</div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "#fff",
                  }}
                >
                  <div
                    style={{ color: "#fff" }}
                    class="text-sm text-gray-500 dark:text-gray-400"
                  >
                    May 26,2020
                  </div>
                  <svg
                    style={{ marginRight: 10, marginLeft: 10 }}
                    stroke="currentColor"
                    fill="#fff"
                    stroke-width="0"
                    viewBox="0 0 512 512"
                    class="css-uk6cul"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                  </svg>
                  2min
                </div>
              </div>
            </div>
            <div className={classes["eye-main"]}>
              <div className={classes["eye-container"]}>
                <svg
                  style={{ width: "20px", fill: "#fff" }}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 576 512"
                >
                  <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z" />
                </svg>
                <p>1000</p>
              </div>
              <svg
                style={{ width: "20px", fill: "#fff", marginLeft: "25px" }}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
              >
                <path d="M384 24c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22V224H352 337.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C242.8 374.8 160 333.4 160 240c0-79.5 64.5-144 144-144h80V24zM0 144C0 99.8 35.8 64 80 64H96c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V416c0-17.7 14.3-32 32-32s32 14.3 32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V144z" />
              </svg>
            </div>
          </div>
          <div className={classes["main-box"]}>
            <div className={classes["cat-name"]}>
              <p>React</p>
            </div>
            <Link to="/detail">
              <h3>How To Create a Responsive Top Navigation Menu</h3>
            </Link>
            {/* <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Explicabo, distinctio aperiam! Iusto quae nemo veniam, sapiente
              sit blanditiis fugiat neque!
            </p> */}
            <div style={{ marginTop: 20 }} class="flex items-center space-x-4">
              <img
                style={{
                  background: "#E2E8F0",
                  width: "50px",
                  marginRight: 15,
                }}
                class="w-10 h-10 rounded-full"
                src={photo}
                alt=""
              />
              <div class="font-medium dark:text-white">
                <div style={{ color: "#fff" }}>Jese Leos</div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "#fff",
                  }}
                >
                  <div
                    style={{ color: "#fff" }}
                    class="text-sm text-gray-500 dark:text-gray-400"
                  >
                    May 26,2020
                  </div>
                  <svg
                    style={{ marginRight: 10, marginLeft: 10 }}
                    stroke="currentColor"
                    fill="#fff"
                    stroke-width="0"
                    viewBox="0 0 512 512"
                    class="css-uk6cul"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                  </svg>
                  2min
                </div>
              </div>
            </div>
            <div className={classes["eye-main"]}>
              <div className={classes["eye-container"]}>
                <svg
                  style={{ width: "20px", fill: "#fff" }}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 576 512"
                >
                  <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z" />
                </svg>
                <p>1000</p>
              </div>
              <svg
                style={{ width: "20px", fill: "#fff", marginLeft: "25px" }}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
              >
                <path d="M384 24c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22V224H352 337.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C242.8 374.8 160 333.4 160 240c0-79.5 64.5-144 144-144h80V24zM0 144C0 99.8 35.8 64 80 64H96c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V416c0-17.7 14.3-32 32-32s32 14.3 32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V144z" />
              </svg>
            </div>
          </div>
          <div className={classes["main-box"]}>
            <div className={classes["cat-name"]}>
              <p>React</p>
            </div>
            <Link to="/detail">
              <h3>How To Create a Responsive Top Navigation Menu</h3>
            </Link>
            {/* <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Explicabo, distinctio aperiam! Iusto quae nemo veniam, sapiente
              sit blanditiis fugiat neque!
            </p> */}
            <div style={{ marginTop: 20 }} class="flex items-center space-x-4">
              <img
                style={{
                  background: "#E2E8F0",
                  width: "50px",
                  marginRight: 15,
                }}
                class="w-10 h-10 rounded-full"
                src={photo}
                alt=""
              />
              <div class="font-medium dark:text-white">
                <div style={{ color: "#fff" }}>Jese Leos</div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "#fff",
                  }}
                >
                  <div
                    style={{ color: "#fff" }}
                    class="text-sm text-gray-500 dark:text-gray-400"
                  >
                    May 26,2020
                  </div>
                  <svg
                    style={{ marginRight: 10, marginLeft: 10 }}
                    stroke="currentColor"
                    fill="#fff"
                    stroke-width="0"
                    viewBox="0 0 512 512"
                    class="css-uk6cul"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                  </svg>
                  2min
                </div>
              </div>
            </div>
            <div className={classes["eye-main"]}>
              <div className={classes["eye-container"]}>
                <svg
                  style={{ width: "20px", fill: "#fff" }}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 576 512"
                >
                  <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z" />
                </svg>
                <p>1000</p>
              </div>
              <svg
                style={{ width: "20px", fill: "#fff", marginLeft: "25px" }}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
              >
                <path d="M384 24c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22V224H352 337.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C242.8 374.8 160 333.4 160 240c0-79.5 64.5-144 144-144h80V24zM0 144C0 99.8 35.8 64 80 64H96c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V416c0-17.7 14.3-32 32-32s32 14.3 32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V144z" />
              </svg>
            </div>
          </div>
          <div className={classes["main-box"]}>
            <div className={classes["cat-name"]}>
              <p>React</p>
            </div>
            <Link to="/detail">
              <h3>How To Create a Responsive Top Navigation Menu</h3>
            </Link>
            {/* <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Explicabo, distinctio aperiam! Iusto quae nemo veniam, sapiente
              sit blanditiis fugiat neque!
            </p> */}
            <div style={{ marginTop: 20 }} class="flex items-center space-x-4">
              <img
                style={{
                  background: "#E2E8F0",
                  width: "50px",
                  marginRight: 15,
                }}
                class="w-10 h-10 rounded-full"
                src={photo}
                alt=""
              />
              <div class="font-medium dark:text-white">
                <div style={{ color: "#fff" }}>Jese Leos</div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "#fff",
                  }}
                >
                  <div
                    style={{ color: "#fff" }}
                    class="text-sm text-gray-500 dark:text-gray-400"
                  >
                    May 26,2020
                  </div>
                  <svg
                    style={{ marginRight: 10, marginLeft: 10 }}
                    stroke="currentColor"
                    fill="#fff"
                    stroke-width="0"
                    viewBox="0 0 512 512"
                    class="css-uk6cul"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                  </svg>
                  2min
                </div>
              </div>
            </div>
            <div className={classes["eye-main"]}>
              <div className={classes["eye-container"]}>
                <svg
                  style={{ width: "20px", fill: "#fff" }}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 576 512"
                >
                  <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z" />
                </svg>
                <p>1000</p>
              </div>
              <svg
                style={{ width: "20px", fill: "#fff", marginLeft: "25px" }}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
              >
                <path d="M384 24c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22V224H352 337.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C242.8 374.8 160 333.4 160 240c0-79.5 64.5-144 144-144h80V24zM0 144C0 99.8 35.8 64 80 64H96c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V416c0-17.7 14.3-32 32-32s32 14.3 32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V144z" />
              </svg>
            </div>
          </div>
        </Slider>
      </div>
    </div>
  );
};

export default Section1;
